<template>
    <rkm-layout-body title="Lista de bloqueio de jornada">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'ambulatorio-jornada-bloqueio-create' })"
                authorize="store-ambulatorio-jornada-bloqueio"
                color="primary"
            >
                Cadastrar bloqueio de jornada
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/jornada-bloqueio/List'

export default {
    components: {List},
}
</script>